import { render, staticRenderFns } from "./LapidusResidents.vue?vue&type=template&id=152acd0f&"
import script from "./LapidusResidents.vue?vue&type=script&lang=js&"
export * from "./LapidusResidents.vue?vue&type=script&lang=js&"
import style0 from "./LapidusResidents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports